import { html } from 'lit'
import { AppElement } from "./mixins.js"


export class ViewSelector extends AppElement {

    static get properties() {
        return {
          view:     { type: String },  
          trigger:  { type: String },
        }
    }

    update(changedProperties) {
        super.update(changedProperties);
    
        if (changedProperties.has('trigger')) {
            const oldTrigger = changedProperties.get('trigger');
            if (oldTrigger) {
                this.unsubscribe(oldTrigger, this.triggerHandler)
            }
            this.subscribe(this.trigger, this.triggerHandler.bind(this))
        }
    }


    render() {
        return html`
            <slot name="${this.view}"></slot>
        `
    }

    triggerHandler(payload) {
        this.view = payload
    }
}

window.customElements.define('view-selector', ViewSelector)